/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { HttpParams } from "@angular/common/http";
import { of } from "rxjs";
import { FilterRequest } from "../../../../models/http/dashboard/filter-page-response.model";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import { MOCK_APPLICATIONS, MOCK_LAYERS, paginate } from "./dashboard-software-assets-filters.db";

const DEFAULT_PAGE_SIZE = 20;

export class DashboardSoftwareAssetsFilters {
	/**
	 * Mock for GET /api/v1/dashboard/users/filters/applications-ids
	 *
	 * No body, no allSelected. Query params: cursor?, size?, search?
	 * Returns a paginated list of FilterApplication.
	 */
	public static getApplicationsIds(options: HttpRequestOptions) {
		const p = options.params as HttpParams | undefined;
		const search = (p?.get("search") ?? "").toLowerCase();
		const size = p?.get("size") ? parseInt(p.get("size")!, 10) : DEFAULT_PAGE_SIZE;
		const cursor = p?.get("cursor") ?? null;

		const candidates = MOCK_APPLICATIONS.filter(
			app => !search || app.name.toLowerCase().includes(search)
		);

		return of(paginate(candidates, cursor, size));
	}

	/**
	 * Mock for POST /api/v1/dashboard/users/filters/layer-ids
	 *
	 * Query params: cursor?, size?, search?
	 * Body: FilterRequest { allSelected, selectedIds?, excludedIds? }
	 *   - selectedIds = application names used to scope the layers
	 *   - allSelected / excludedIds = layer selection state for the backend
	 */
	public static getLayerIds(options: HttpRequestOptions) {
		const p = options.params as HttpParams | undefined;
		const body = options.body as FilterRequest | undefined;

		const search = (p?.get("search") ?? "").toLowerCase();
		const size = p?.get("size") ? parseInt(p.get("size")!, 10) : DEFAULT_PAGE_SIZE;
		const cursor = p?.get("cursor") ?? null;

		// selectedIds in the body carry the application names to scope layers
		const appNames: string[] =
			body?.selectedIds && body.selectedIds.length > 0
				? body.selectedIds
				: Object.keys(MOCK_LAYERS);

		const allLayers = [...new Set(appNames.flatMap(name => MOCK_LAYERS[name] ?? []))];

		let candidates = allLayers.filter(layer => !search || layer.toLowerCase().includes(search));

		// Honour allSelected + excludedIds (layer-level selection state)
		if (body?.allSelected && body.excludedIds?.length) {
			const excluded = new Set(body.excludedIds);
			candidates = candidates.filter(l => !excluded.has(l));
		}

		return of(paginate(candidates, cursor, size));
	}
}
